<script>
import _ from 'lodash';

import { authComputed, authMethods, clientComputed, clientMethods, trainerComputed } from '@state/helpers';

export default {
  name: 'PersonalCurrentWeightMobile',
  components: {},
  data() {
    return {
      currentWeight: 0,

      updatingClient: false,
    };
  },
  mounted() {
    this.initalizeLocalState();
  },
  methods: {
    ...authMethods,
    ...clientMethods,
    initalizeLocalState() {
      this.currentWeight = this.userProgress.initial.weight.value;
    },
    async handleSubmitCurrentWeight() {
      this.updatingClient = true;

      const payload = {
        client: {
          profile: this.userProfile,
          progress: {
            ...this.userProgress,
          },
        },
      };

      payload.client.progress.initial.weight.value = this.currentWeight;
      const response = await this.updateClient({ clientId: this.clientId, trainerId: this.trainerId, payload });

      if (response.success === false) {
        console.error('response: ', response);
      } else {
        const updatedUser = _.cloneDeep(this.currentUser);
        updatedUser.user = response.client;
        this.setCurrentUser(updatedUser);

        if (this.userMainGoal === 'Other') {
          await this.updateOnboardingProgress(5);
          this.$router.push({ name: 'personalConditions' }).catch((err) => {
            if (err !== undefined) {
              console.error(err);
            }
          });
        } else {
          await this.updateOnboardingProgress(4);
          this.$router.push({ name: 'personalGoalWeight' }).catch((err) => {
            if (err !== undefined) {
              console.error(err);
            }
          });
        }
      }

      this.updatingClient = false;
    },
  },
  computed: {
    ...authComputed,
    ...clientComputed,
    ...trainerComputed,
  },
};
</script>

<template>
  <div class="page">
    <BaseProgressBar class="base-progress-bar" :limit="7" :progress="userMainGoal === 'Other' ? 4 : 3" />
    <div class="container">
      <div class="header">
        <div class="title">
          <h1>What’s your current weight?</h1>
        </div>
        <div class="subtitle">
          <p>
            I know your goals are measured by more than just what the scale says, but these numbers help with other calculations
            in the app to track progress.
          </p>
        </div>
      </div>
      <div class="form">
        <form>
          <div class="weight">
            <BaseInputTextWithLabel
              id="weight"
              type="number"
              label="Current Weight (lbs)"
              classStyle="simple"
              placeholder="lbs"
              v-model="currentWeight"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="buttons">
      <div id="back">
        <router-link :to="userMainGoal === 'Other' ? '/signup/personal-motivation' : '/signup/Personal-goals'">
          <BaseButton class="large-transparent">
            <img src="@assets/images/icons/left-arrow.svg" />
            Back
          </BaseButton>
        </router-link>
      </div>
      <div id="next">
        <BaseButton class="large" @click="handleSubmitCurrentWeight" :disabled="updatingClient">
          Next
          <img src="@assets/images/icons/right-arrow.svg" />
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
// stylelint-disable selector-pseudo-element-no-unknown

.page {
  margin: auto;
  position: relative;
  width: 400px;

  .progress-bar {
    left: 40px;
    position: absolute;
    right: 40px;
    top: 40px;
  }

  .container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 18px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 65vh;
    margin-top: 56px;
    overflow: auto;
    padding-bottom: 13rem;
    position: relative;
    width: 400px;

    .header {
      height: 240px;
      margin-bottom: 90px;
      text-align: start;
      width: 100%;

      .title {
        font-family: $base-font-family;
        font-size: 36px;
        font-style: normal;
        font-weight: 800;
        line-height: 42px;
        margin: 90px auto 0;
        width: 90%;
      }

      .subtitle {
        color: black;
        font-family: $secondary-font-family;
        font-size: 16px;
        margin: 0;
        width: 100%;

        p {
          // margin-left: 3.4%;
          line-height: 1.38;
          margin: 0;
          margin-top: 3.25%;
          padding: 0 21px 0 27px;
        }
      }
    }

    .form {
      margin: 0;
      text-align: center;
      width: 100%;

      form {
        ::v-deep label {
          font-family: $proxima-nova;
          font-weight: 600;
        }
        ::v-deep input {
          font-family: $proxima-nova;
          font-weight: normal;
          &::placeholder {
            font-family: $proxima-nova;
            font-weight: normal;
          }
        }
        .weight {
          margin: 0 auto;
          width: 90%;
        }
      }
    }
  }
  .buttons {
    background-color: white;
    bottom: 0;
    float: right;
    position: absolute;
    right: 0;
    width: 100%;
    #next {
      float: right;
      margin-bottom: 20px;
      margin-left: auto;
      margin-right: 5%;
      width: 40%;
      button:disabled {
        background-color: lighten($color: #4059e1, $amount: 20);
      }
    }
    #back {
      display: flex;
      flex-direction: column;
      float: left;
      margin: 0;
      padding: 0 130px 0 31px;
      button {
        border: unset;
      }
      .large-transparent {
        color: #000;
      }
    }
  }
}
</style>
